import { Link } from 'react-router-dom';
import { Typography } from '@arionbanki/arionui';
import { useAdmin } from './useAdmin';

const sizes = [1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1];

export function Admin() {
	const { columns, data, fields, onChange, t, virtualizer, ...ctx } = useAdmin();
	return (
		<>
			<div className="row">
				<div className="col-12">
					<Typography TagName="h3">{t('admin_title')}</Typography>
				</div>
				{fields.map(name => (
					<div className="col-xs-12 col-md-4" key={name}>
						<input
							className="w-100 my-3 py-2 px-3 border border-2 rounded"
							name={name}
							onChange={onChange}
							placeholder={t(name)}
							type="search"
						/>
					</div>
				))}
				<div className="col-12">
					{ctx.isLoading && <Typography TagName="p">{t('loading')}</Typography>}
					{ctx.error && <Typography TagName="p">{t('error')}</Typography>}
				</div>
			</div>
			<div className="row grid-header">
				{columns.map((c, i) => (
					<div className={`col-${sizes[i]} bold flex flex-align-items-center`} key={c}>
						{ctx.sortable[c] ? (
							<a href={`#${c}`} className="sort-link" data-field={c} onClick={ctx.sortColumn}>
								{t(c)}
							</a>
						) : (
							t(c)
						)}
					</div>
				))}
				<div className="col-1 bold flex flex-align-items-center">{t('Details')}</div>
			</div>
			{Array.isArray(data) && data.length ? (
				<div className="border border-1 overflow-auto" ref={ctx.parentRef} style={{ height: `567px` }}>
					<div className="position-relative w-100" style={{ height: `${virtualizer.getTotalSize()}px` }}>
						{virtualizer.getVirtualItems().map(virtualRow => (
							<div
								key={virtualRow.index}
								className={`row m-0 position-absolute w-100 top-0 left-0 ${virtualRow.index % 2 ? '' : 'even'}`}
								style={{ height: `${virtualRow.size}px`, transform: `translateY(${virtualRow.start}px)` }}
							>
								{columns.map((field, i) => (
									<div key={field} className={`col-${sizes[i]} fs-14 flex flex-align-items-center`}>
										{ctx.formatValue(data[virtualRow.index], field, t)}
									</div>
								))}
								<div className="col-1 fs-14 flex flex-align-items-center">
									<Link
										className="text-decoration-none"
										to={`/admin/details/${data[virtualRow.index].agreementProcessId}`}
									>
										&#8230;
									</Link>
								</div>
							</div>
						))}
					</div>
				</div>
			) : null}
		</>
	);
}
